import { Box, MenuList } from '@mui/material'
import MenuLinkComponent from './link.component'
import useSidebarActions from '../../hooks/use-sidebar-actions.hook'

import useSidebarLinks from '../../hooks/use-sidebar-links.hook'

type Props = {
  sidebarStatus: boolean
  handleSidebarOpen: () => void
}

const MenuComponent = ({ sidebarStatus, handleSidebarOpen }: Props) => {
  const { sidebarIds } = useSidebarActions()

  const { links } = useSidebarLinks()

  return (
    <MenuList sx={{ display: 'flex', flexDirection: 'column' }}>
      {links
        .filter((link) => sidebarIds.includes(link.id) && link.visible === true)
        .map((link) => (
          <Box order={link.order} key={link.id}>
            <MenuLinkComponent
              link={link}
              sidebarStatus={sidebarStatus}
              handleSidebarOpen={handleSidebarOpen}
              sidebarIds={sidebarIds}
            />
          </Box>
        ))}
    </MenuList>
  )
}

export default MenuComponent
